/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * DiamondFilledIcon
 */
export default class DiamondFilledIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M15.775 4c1.029 0 1.922.583 2.648 1.255l.152.145 3.503 3.693a3 3 0 01-.146 3.78l-.132.141-7.68 7.68-.036-.036-.055.12-.094.084-.096.08a3 3 0 01-3.818-.114l-.144-.135-7.679-7.68a3 3 0 01-.39-3.763l.112-.158L5.475 5.4c.377-.406.734-.772 1.198-1.012.42-.216.882-.347 1.361-.38L8.275 4h7.5z" fillRule="evenodd"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

